import React, { useState } from 'react';
import { Form } from 'antd';
import { useHistory, useLocation } from 'react-router-dom';
import queryString from 'query-string';
import { setPasswordWithCode } from '../../api/auth';
import { NotificationContainer } from '../../layout/Main';
import appStore from '../../store/App';
import { ResetPasswordForm, ExpiredLinkScreen } from './components';
import Slider from '../Login/components/Slider';
import s from '../Login/styles.module.scss';

interface ResetPasswordFormData {
  password: string;
  confirmPassword: string;
}

export default function ResetPassword() {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [isLinkExpired, setIsLinkExpired] = useState(false);
  const history = useHistory();
  const location = useLocation();

  // Извлекаем code из query параметров
  const { code } = queryString.parse(location.search);

  const onFinish = async (values: ResetPasswordFormData) => {
    if (!code || typeof code !== 'string') {
      appStore.setNotification({
        type: 'error',
        title: 'Invalid reset link. Please request a new password reset link.',
        width: 450,
      });
      return;
    }

    setLoading(true);
    try {
      await setPasswordWithCode({
        code: code as string,
        password: values.password,
      });

      appStore.setNotification({
        type: 'success',
        title: 'Your password has been set successfully!',
        width: 400,
      });

      // Редирект на страницу логина
      history.push('/login');
    } catch (error: any) {
      console.error('Set password error:', error);
      console.log('Error message:', error.message);

      // Проверяем, является ли ошибка "Confirmation Code already used"
      try {
        const errorData = error.response?.data || JSON.parse(error.message);
        console.log('Parsed error data:', errorData);

        // Проверяем разные форматы ошибок
        const isCodeExpired =
          // Формат: {"errors": ["Confirmation Code already used"]}
          errorData?.errors?.[0] === 'Confirmation Code already used' ||
          // Формат: {"errors": [["Confirmation Code already used"]]}
          errorData?.errors?.[0]?.[0] === 'Confirmation Code already used' ||
          // Формат: {"errors": [[{msg: "..."}]]}
          errorData?.errors?.[0]?.[0]?.msg ===
            'Confirmation Code already used' ||
          // Формат: {"detail": [{msg: "..."}]}
          errorData?.detail?.some?.(
            (d: any) => d.msg === 'Confirmation Code already used',
          ) ||
          // Проверяем если errors это массив строк и содержит нужный текст
          (Array.isArray(errorData?.errors) &&
            errorData.errors.includes('Confirmation Code already used'));

        console.log('Is code expired:', isCodeExpired);

        if (isCodeExpired) {
          setIsLinkExpired(true);
          return;
        }
      } catch (parseError) {
        console.error('Error parsing error data:', parseError);
      }

      appStore.setNotification({
        type: 'error',
        title:
          'Failed to set password. The link may have expired. Please request a new link.',
        width: 500,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={s.root}>
      <div className={s.block} style={{ width: '50%', height: '100vh' }}>
        <Slider />
      </div>
      <div
        className={s.block}
        style={{
          padding: '0 70px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <div style={{ width: '452px' }}>
          {isLinkExpired ? (
            <ExpiredLinkScreen />
          ) : (
            <ResetPasswordForm
              form={form}
              loading={loading}
              onFinish={onFinish}
            />
          )}
        </div>
      </div>
      <NotificationContainer />
    </div>
  );
}
